export const isDev = process.env.NODE_ENV === "development";
export const apiUrl = process.env.REACT_APP_API_URL;
export const coreDomain = process.env.REACT_APP_CORE_DOMAIN;
export const partnerPageLink = `https://${process.env.REACT_APP_CORE_DOMAIN}/partner`;
export const partnerPageLinkText = `${process.env.REACT_APP_CORE_DOMAIN}/partner`;
export const partnerEmailSupportLinkText = `partner@${process.env.REACT_APP_CORE_DOMAIN}`;
export const partnerEmailSupportLink = `mailto:partner@${process.env.REACT_APP_CORE_DOMAIN}`;
export const ciwLinkPrefix = `https://${process.env.REACT_APP_CIW_DOMAIN_PREFIX}${process.env.REACT_APP_CORE_DOMAIN}${process.env.REACT_APP_CIW_PATH_PREFIX}`;
